import React from "react";
import ReactAnimatedWeather from 'react-animated-weather';

export default function WeatherIcon(props){
  
  const codeMapping = {
       'clear-sky-day':'CLEAR_DAY',
        'clear-sky-night':'CLEAR_NIGHT',
        'few-clouds-day': 'PARTLY_CLOUDY_DAY',
        'few-clouds-night':'PARTLY_CLOUDY_NIGHT',
        'scattered-clouds-day': 'CLOUDY',
        'scattered-clouds-night':'CLOUDY', 
        'broken-clouds-day': 'CLOUDY',
        'broken-clouds-night': 'CLOUDY',
        'rain-day':'RAIN',
        'rain-night':'RAIN',
        'shower-rain-day':'SLEET',
        'shower-rain-night':'SLEET',
        'snow-day': 'SNOW',
        'snow-night': 'SNOW',
        'thunderstorm-day': 'WIND',
        'thunderstorm-night': 'WIND',
        'mist-day': 'FOG',
        'mist-night': 'FOG'
    };
    
    return (
     <ReactAnimatedWeather
    icon={codeMapping[props.code]}
    color= 'skyblue'
    size={props.size}
    animate={true} />
);
}